// Ctrl+Enter is the conventional desktop submit shortcut. Treat Command as
// its macOS equivalent, while leaving modified variants and IME composition
// alone so they cannot publish unexpectedly.
export function isComposeSubmitShortcut(event) {
  return Boolean(event && event.key === "Enter"
    && (event.ctrlKey || event.metaKey)
    && !event.altKey
    && !event.shiftKey
    && !event.isComposing);
}
